var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-table-index mobile-t-sub-form",
      attrs: { id: _vm.value, name: _vm.value },
    },
    [
      _vm._l(_vm.value, function (valueItem, index) {
        return _c(
          "div",
          { key: index, staticClass: "card" },
          [
            _c(
              "van-cell",
              {
                staticClass: "block-title",
                attrs: { title: "序号：" + (index + 1) },
              },
              [
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.updateDomain(index, valueItem)
                        },
                      },
                    },
                    [_vm._v("修改")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.copyDomain(valueItem)
                        },
                      },
                    },
                    [_vm._v("复制")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.removeDomain(index)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ],
              ],
              2
            ),
            _c(
              "van-cell-group",
              { attrs: { border: false } },
              _vm._l(_vm.item.childList, function (option) {
                return _c("van-cell", {
                  key: option.vModel,
                  attrs: {
                    title: _vm.getTableColumnLabel(option),
                    value: _vm.showText(valueItem, option.vModel),
                  },
                })
              }),
              1
            ),
          ],
          1
        )
      }),
      _c(
        "el-button",
        {
          staticClass: "button",
          attrs: { type: "primary", size: "mini", disabled: _vm.disabled },
          on: { click: _vm.addDomain },
        },
        [_vm._v(" 增 加 ")]
      ),
      _vm.addOrUpdateVisible
        ? _c("AddOrUpdate", {
            ref: "addOrUpdate",
            attrs: { fields: _vm.item.childList },
            on: { submit: _vm.handleFormSubmit },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }